import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";
import { APPOINTMENT_EDIT, CHATTER_LESSON_EDIT, CHATTER_LESSON_LIST, CLIENT_CONSENT_FORMS_LIST, MANAGE_PARENT_TASKS_LIST, MANAGE_PARENTS_EDIT, MANAGE_PARENTS_LIST, THERAPIST_DETAIL } from "config/paths";
import { useChatterLessonDetailsQuery } from "store/services/chatter/lesson";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useDeleteAppointmentMutation, useGetAppointmentClientsListQuery, useGetParentAppointmentsListQuery } from "store/services/appointment";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import TableLayout from "components/TableLayout";
import { convertToMomentDate, successMessageToast, userFullName } from "helpers/common";
import { CommonToolTip, CstmPagination } from "components/Common/Common";
import { DeleteIcon, EditIcon } from "Assets/icons";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { APPOINTMENT_SESSION_TYPE_OPTIONS, CLIENT_TYPE_OPTIONS, PARENT_PANEL_URL } from "config/constants";
import { useMasterLoginMutation } from "store/services/auth";
import { useSelector } from "react-redux";

const ParentDetail = () => {
  const lessonId = 100
  const { id } = useParams();
  const navigate = useNavigate();
  const lessonDetails = [{}, {}]
  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 10
  const [filter, setFilter] = useState({ search: "", appointment_type: "", status: "active" })
  const [modalType, setModalType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);

  const { data: parentDetails, isLoading, isError } = useGetAppointmentClientsListQuery({ body: "", parentId: id });
  const { data: appointments, isLoading: appointmentsLoading, isFetching: appointmentsFetching, isError: appointmentsError } = true ? {} : useGetParentAppointmentsListQuery({ ...filter, id, page: currentPage, limit: pageSize })
  const totalRecords = appointments?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);
  const [deleteAppointment, { isLoading: deleteAppointmentLoading }] = useDeleteAppointmentMutation();
  const [parentLogin, { isLoading: parentLoginLoading }] = useMasterLoginMutation()
  const profile = useSelector((state) => state?.auth?.user)


  const column = [
    {
      head: "Last Name",
      accessor: "lastname",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{item?.lastname || "--"}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{item?.firstname || "--"}</h6>
      ),
    },
    {
      head: "Gender",
      accessor: "gender",
      isComponent: true,
      // sorter: true,
      component: (item, ind) => (
        <h6 style={{ textTransform: "capitalize" }} className="m-0 fw-bold themeBlue">{item?.client_detail?.gender || "--"}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "selectAll",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{convertToMomentDate(item?.client_detail?.dob)}</h6>
      ),
    },
    {
      head: "City/Town",
      accessor: "city_town",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{item?.client_detail?.city_town}</h6>
      ),
    },
    {
      head: "Client Type",
      accessor: "selectAll",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold themeBlue">{CLIENT_TYPE_OPTIONS?.find((x) => x?.value == item?.client_detail?.client_type)?.label || "--"}</h6>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Button
            type="button"
            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
            style={{ height: "30px", minWidth: "60px" }}
            onClick={(e) => {
              e.stopPropagation(); navigate(generatePath(MANAGE_PARENT_TASKS_LIST, {
                parentId: id,
                clientId: item?.id
              }))
            }}

          >
            Tasks
          </Button>
          <Button
            type="button"
            className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
            style={{ height: "30px", minWidth: "60px" }}
            onClick={(e) => {
              e.stopPropagation(); navigate(generatePath(CLIENT_CONSENT_FORMS_LIST, {
                parentId: id,
                id: item?.id
              }))
            }}

          >
            View Details
          </Button>
        </div>
      ),
    },
    // {
    //   head: "Phone Number",
    //   accessor: "phone",
    //   sorter: true,
    //   component: (item, ind) => (
    //     <p>{item?.phone || "--"}</p>
    //   ),
    // },
    // {
    //   head: "Email",
    //   accessor: "email",
    //   isComponent: true,
    //   sorter: true,
    //   component: (item, ind) => (
    //     <p className="cell-text-ellipsis">{item?.email || "--"}</p>
    //   ),
    // },
    // {
    //   head: "Status",
    //   accessor: "status",
    //   sorter: true,
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <p
    //       style={{ width: 80 }}
    //       className={`${item.status == "active"
    //         ? "greenStatus"
    //         : "redStatus"
    //         } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
    //     >
    //       {item.status}
    //     </p>
    //   ),
    // },
    // {
    //   head: "Action",
    //   accessor: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn d-flex align-items-center  gap-10">
    //       {/* <CommonToolTip
    //         text={"Edit"}
    //         component={<Button
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //           onClick={() => navigate(MANAGE_PARENTS_EDIT.replace(":id", item.id))}
    //         >
    //           <EditIcon />
    //         </Button>}
    //       /> */}
    //       {/* <CommonToolTip
    //         text={item?.status == "active" ? "Archive" : "Unarchive"}
    //         component={<Button
    //           onClick={() => {
    //             setModalType(item?.status == "active" ? "archive" : "active");
    //             setCurrentEntry(item);
    //             setShowModal(true);
    //           }} className="p-0"
    //           variant="transparent"
    //           type="button"
    //         >
    //           {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
    //         </Button>}
    //       />
    //       <CommonToolTip
    //         text={"Delete"}
    //         component={<Button
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //           onClick={() => {

    //             setCurrentEntry(item);
    //             setModalType("delete");
    //             setShowModal(true);
    //           }}
    //         >
    //           <DeleteIcon />
    //         </Button>}
    //       /> */}
    //     </div>
    //   ),
    // },
  ]

  const appointmentsColumn = [
    {
      head: "Title",
      accessor: "title",
      // sorter: true,
      component: (item) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold">
            <Link
              className="text-dark"
              to={generatePath(THERAPIST_DETAIL, { id: item.id })}
            >
              {item.title || "--"}
            </Link>
          </h6>
        </div>)
    },
    {
      head: <div className="w-100 d-flex justify-content-center">Client</div>,
      accessor: "client_id",
      // sorter: true,
      component: (item, index) => (
        <p className="text_cap text-center">{userFullName(item?.appointmentClient) || "--"}</p>
      )
    },
    {
      head: <div className="w-100 d-flex justify-content-center">Parent</div>,
      accessor: "guardian_id",
      component: (item, index) => (
        <p className="text_cap text-center">{userFullName(item?.appointmentGuardian)}</p>
      )
    },
    {
      head: <div className="w-100 d-flex justify-content-center">Appointment</div>,
      accessor: "appointment_type",
      isComponent: true,
      component: (item, index) => (
        <p className="text_cap text-center">{item?.appointment_type}</p>
      )
    },
    {
      head: "Payment Status",
      accessor: "payment_status",
      // sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <p
          style={{ width: 80 }}
          className={`${item?.appointment_type == "funded" ? "redStatus" : item.payment_status == "success"
            ? "greenStatus"
            : item.payment_status == "pending" ? "yellowStatus" : "redStatus"
            } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
        >
          {item?.appointment_type == "funded" ? "N/A" : item.payment_status}
        </p>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item, x) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <CommonToolTip
            text={"Edit"}
            component={<Button
              disabled={item.payment_status == "success"}
              onClick={(e) => {
                e.stopPropagation()
                navigate(generatePath(APPOINTMENT_EDIT, { id: item?.id }))
              }}
              className="p-0"
              variant="transparent"
              type="button"
            >
              <EditIcon />
            </Button>}
          />
          <CommonToolTip
            text={"Delete"}
            component={<Button
              disabled={item.payment_status == "success"}
              onClick={(e) => {
                e.stopPropagation()
                setModalType("delete")
                setCurrentEntry(item);
                setShowModal(true);
              }}
              className="p-0"
              variant="transparent"
              type="button"
            >
              <DeleteIcon />
            </Button>}
          />
        </div>
      ),
    },
  ]

  const resetFilter = () => {
    setFilter({ search: "", appointment_type: "", status: "active" });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter({ ...filter, [key]: value })
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleDeleteAppointment = async () => {
    try {

      setShowModal(false);

      // const list = [...therapistProfiles];
      // const index = therapistProfiles?.findIndex(x => x.id === currentEntry?.id);
      // delete list[index];
      // setTherapistProfiles(list.filter(Boolean));

      const response = await deleteAppointment({ id: currentEntry?.id }).unwrap();
      console.log('result response', response)
      successMessageToast(response?.message);

    } catch (err) {
      console.log("error deleting appointment", err);
    }
  };

  const handleParentLogin = async () => {
    const body = {
      username: parentDetails?.parentDetails?.email,
      source: "admin",
      destination: "parent",
      adminEmail: profile?.email
    }
    try {
      const result = await parentLogin({ body }).unwrap()
      window.open(`${PARENT_PANEL_URL}/login?token=${result?.token}`)
    } catch (error) {
      console.log('error logging in as parent: ', error)
    }

  }

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={modalType == "delete" ? handleDeleteAppointment : handleDeleteAppointment}
        type={modalType}
      />
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>
          <Row>
            <Col
              lg="12"
              className=""
              style={{ borderRight: "1px solid #3da0aa4f" }}
            >
              <Row>
                <Col lg="12" className="my-3">
                  <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                    <div className="left">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                        <li className="">
                          <Link
                            className="themeBlue fw-sbold back-to-btn"
                            to={MANAGE_PARENTS_LIST}
                          >
                            <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                            </svg> Back
                          </Link>
                        </li>
                        <li className="">
                          <Link
                            className="themeBlue fw-sbold"
                            style={{ textDecoration: "underline" }}
                            to={MANAGE_PARENTS_LIST}
                          >
                            Parents
                          </Link>
                        </li>
                        <li className="">
                          <h5 className="m-0 fw-bold themeBlue">/ Details</h5>
                        </li>
                      </ul>
                    </div>

                    <div className="right">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                        <li className="">
                          <Button
                            className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                            variant="outline-success"
                            onClick={() => navigate(MANAGE_PARENTS_EDIT.replace(":id", id))}
                          >
                            <span className="icn me-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <mask
                                  id="mask0_0_2439"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="18"
                                >
                                  <rect width="18" height="18" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_0_2439)">
                                  <path
                                    d="M1.5 17.9997V15.7497H16.5V17.9997H1.5ZM4.5 12.3099H5.42737L11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L4.5 11.3825V12.3099ZM3.375 13.4349V10.9036L11.7823 2.50792C11.8909 2.3993 12.0142 2.31711 12.1523 2.26136C12.2901 2.20561 12.4336 2.17773 12.5828 2.17773C12.732 2.17773 12.8765 2.20561 13.0163 2.26136C13.156 2.31711 13.2841 2.40317 13.4004 2.51955L14.3019 3.43249C14.4183 3.54111 14.5024 3.66555 14.5543 3.8058C14.6062 3.94592 14.6321 4.0908 14.6321 4.24042C14.6321 4.38067 14.6058 4.52011 14.5532 4.65873C14.5006 4.79748 14.4168 4.9243 14.3019 5.03917L5.90625 13.4349H3.375ZM11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L11.6524 6.0963Z"
                                    fill="currentColor"
                                  />
                                </g>
                              </svg>
                            </span>
                            Edit
                          </Button>
                        </li>
                        <li className="">
                          <Button
                            className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                            variant="outline-success"
                            onClick={() => handleParentLogin()}
                          >
                            <span className="icn me-1">
                              {/* <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                              >
                                <mask
                                  id="mask0_0_2439"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="18"
                                  height="18"
                                >
                                  <rect width="18" height="18" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_0_2439)">
                                  <path
                                    d="M1.5 17.9997V15.7497H16.5V17.9997H1.5ZM4.5 12.3099H5.42737L11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L4.5 11.3825V12.3099ZM3.375 13.4349V10.9036L11.7823 2.50792C11.8909 2.3993 12.0142 2.31711 12.1523 2.26136C12.2901 2.20561 12.4336 2.17773 12.5828 2.17773C12.732 2.17773 12.8765 2.20561 13.0163 2.26136C13.156 2.31711 13.2841 2.40317 13.4004 2.51955L14.3019 3.43249C14.4183 3.54111 14.5024 3.66555 14.5543 3.8058C14.6062 3.94592 14.6321 4.0908 14.6321 4.24042C14.6321 4.38067 14.6058 4.52011 14.5532 4.65873C14.5006 4.79748 14.4168 4.9243 14.3019 5.03917L5.90625 13.4349H3.375ZM11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L11.6524 6.0963Z"
                                    fill="currentColor"
                                  />
                                </g>
                              </svg> */}
                            </span>
                            Login as parent
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Col>
                {
                  isLoading ? <LoadingIndicator /> :
                    <Col lg="12" className="my-3">
                      {/* <div className="top d-flex align-items-center gap-10">
                        <div
                          className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                          style={{ height: 35, width: 35, background: "#DBDBDB" }}
                        >
                          {lessonDetails?.title?.[0]?.toUpperCase() || ""}
                        </div>
                        <div className="content">
                          <h6 className="m-0 themeBlue fw-sbold">{lessonDetails?.title || "--"}</h6>
                        </div>
                      </div> */}
                      <Row>
                        <Col md="3" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              First Name
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{parentDetails?.parentDetails?.firstname || "--"}</p>
                          </div>
                        </Col>
                        <Col md="3" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Last Name
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{parentDetails?.parentDetails?.lastname || "--"}</p>
                          </div>
                        </Col>
                        <Col md="3" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Email
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{parentDetails?.parentDetails?.email || "--"}</p>
                          </div>
                        </Col>
                        <Col md="3" sm="6" className="my-2">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Phone
                            </h6>
                            <p className="m-0 forteen themeBlue pt-2">{parentDetails?.parentDetails?.phone || "--"}</p>
                          </div>
                        </Col>
                        {/* <Col md="5" sm="6" className="my-2">
                            <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                              <h6 className="m-0 themeBlue fw-bold">
                                {" "}
                                <span className="" style={{ color: "#3DA0AA" }}>
                                  ■
                                </span>{" "}
                                Files
                              </h6>
                              <ul>
                                {
                                  lessonDetails?.files?.map((item, index) => {
                                    return (<li><p key={index} className="m-0 forteen themeBlue pt-2">{item?.attachment_name || "--"}</p></li>)
                                  })
                                }
                              </ul>

                            </div>
                          </Col> */}
                        <Col lg="12" className="my-3">
                          <h6 className="m-0 themeBlue fw-sbold">Clients: </h6>
                          {/* <p className="m-0 forteen themeBlue">
                            {lessonDetails?.description || "--"}
                          </p> */}
                        </Col>
                        <div className="table-outer">
                          {isLoading ? (
                            <div style={{ height: "200px" }}>
                              <LoadingIndicator />
                            </div>
                          ) : isError ? (
                            <ErrorComponent />
                          ) : (
                            <>
                              {(isLoading || parentLoginLoading) && (
                                <LoadingOverlay />
                              )}
                              <TableLayout data={parentDetails?.records} column={column} />
                            </>
                          )}
                          {/* <CstmPagination
                        totalPages={totalPages}
                        activePage={currentPage}
                        handlePageChange={handlePageChange}
                      /> */}
                        </div>

                        {/* <Col lg="12" className="my-3">
                          <TableHeader
                            heading={"Appointments"}
                            hideStatusFilter
                            handleFilterChange={handleFilterChange}
                            resetFilter={resetFilter}
                            filter={filter}
                            searchPlaceholder="Last, First Name, Email"
                          filterComponent={
                            <>
                              <li className="">
                                <Dropdown
                                  onSelect={handleFilterChange("appointment_type")}
                                >
                                  <Dropdown.Toggle
                                    variant="transparent"
                                    className="border-0 d-flex align-items-center  justify-content-center"
                                    id="dropdown-basic"
                                  >
                                    {<div style={{ textTransform: "capitalize" }}>{filter.appointment_type || "Select Type"}</div>}
                                    <span className="icn ms-2">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12"
                                        height="8"
                                        viewBox="0 0 12 8"
                                        fill="none"
                                      >
                                        <path
                                          d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                          fill="black"
                                        />
                                      </svg>
                                    </span>
                                  </Dropdown.Toggle>

                                  <Dropdown.Menu
                                    style={{
                                      maxHeight: "200px",
                                      overflowY: "scroll"
                                    }}
                                  >
                                    {
                                      APPOINTMENT_SESSION_TYPE_OPTIONS.map((item, index) => {
                                        return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                      })
                                    }
                                  </Dropdown.Menu>
                                </Dropdown>
                              </li>
                            </>
                          }
                          >
                          </TableHeader>
                        </Col>
                        <div className="table-outer">
                          {appointmentsLoading ? (
                            <div style={{ height: "200px" }}>
                              <LoadingIndicator />
                            </div>
                          ) : appointmentsError ? (
                            <ErrorComponent />
                          ) : (
                            <>
                              {(appointmentsFetching || deleteAppointmentLoading) && (
                                <LoadingOverlay />
                              )}
                              <TableLayout
                                data={appointments?.records}
                                column={appointmentsColumn}
                                url={'/appointment/details'}
                                filter={filter}
                              // handleSort={handleFilterChange("sort")}
                              />
                            </>
                          )}
                          <CstmPagination
                            totalPages={totalPages}
                            activePage={currentPage}
                            handlePageChange={handlePageChange}
                          />
                        </div> */}
                      </Row>
                    </Col>
                }
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ParentDetail;
